import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Globals } from '../../_models/globals';
import { ExcelServiceService } from '../../_models/excel-service.service';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-seller-reports-details',
  templateUrl: './seller-reports-details.component.html',
  styleUrls: ['./seller-reports-details.component.scss'],
})
export class SellerReportsDetailsComponent implements OnInit {

  startDate: any;
  endDate: any;
  // sourceType : any;
  type: any;
  orderList: any;
  orderListLength: boolean;
  startDateError: string;
  endDateError: string;
  paymentStatus: string;
  paymentStatusError: string;

  constructor(private excelService: ExcelServiceService, private route: ActivatedRoute, private alertService: AlertService, private api: ApiIntegration, private user: User, private g: Globals) {
    this.type = this.route.snapshot.queryParams.type;
  }

  exportToXLSX() {
    this.excelService.exportAsExcelFile(this.orderList, 'sample');
  }

  exportToPdf(action = 'open') {
    const documentDefinition = this.getDocumentDefinition();
    switch (action) {
      case 'open':
        pdfMake.createPdf(documentDefinition).open();
        break;
      case 'print':
        pdfMake.createPdf(documentDefinition).print();
        break;
      case 'download':
        pdfMake.createPdf(documentDefinition).download();
        break;
      default:
        pdfMake.createPdf(documentDefinition).open();
        break;
    }
  }

  getReportsData() {
    let reportsData = [];
    if (this.type == 'Order Detail') {
      reportsData.push([{ text: 'Order #', style: 'headerText' }, {
        text: 'Warehouse Name',
        style: 'headerText'
      }, { text: 'Customer Name', style: 'headerText' }, {
        text: 'Contact Name',
        style: 'headerText'
      }, { text: 'Created Date', style: 'headerText' }, { text: 'Order Type', style: 'headerText' }, {
        text: 'Channel Name',
        style: 'headerText'
      }, { text: 'Status', style: 'headerText' }]);
      this.orderList.forEach((od) => {
        reportsData.push([{ text: od.orderNumber, style: 'content' }, {
          text: od.warehouseName,
          style: 'content'
        }, { text: od.ownerName, style: 'content' }, { text: od.contactName, style: 'content' }, {
          text: od.createdDate,
          style: 'content'
        }, { text: od.orderType, style: 'content' }, { text: od.channelName, style: 'content' }, {
          text: od.orderStatus,
          style: 'content'
        }]);
      });
    } else {
      return true;
    }
    return reportsData;
  }


  clearFields() {
    this.startDate = "";
    this.endDate = "";
    //  this.sourceType = "";
    this.orderList = "";
    this.orderListLength = false;
    this.startDateError = "";
    this.endDateError = "";
  }

  ngOnInit() {
  }

  getDocumentDefinition() {
    return {
      pageSize: 'A4',
      pageMargins: [30, 25, 30, 15],
      header: {
        margin: [20, 10, 10, 10],
        columns: [
          { text: this.g.page, alignment: 'center', style: 'tableHeaders', bold: 'true' }
        ]
      },
      content: [
        {
          style: 'tableExample',
          table: {
            widths: [50, 50, 50, 50, 50, 30, 30, 40],
            body: this.getReportsData()
          }
        }
      ],
      styles: {
        content: {
          fontSize: 5
        },
        tableHeaders: {
          fontSize: 8,
          bold: true
        },
        headerText: {
          fontSize: 6,
          color: '#FFFFFF',
          fillColor: '#0074C1',
          bold: true
        }
      }

    };
  }

  validation() {
    if (this.type == 'Order Detail') {
      this.startDateError = "";
      this.endDateError = "";

      if (this.startDate == '' || this.startDate === null || this.startDate === undefined || this.startDate === 'undefined') {
        this.startDateError = 'Please select start date';
      }
      if (this.endDate == '' || this.endDate === null || this.endDate === undefined || this.endDate === 'undefined') {
        this.endDateError = 'Please select end date';
      }

      if (this.startDateError != "" || this.endDateError != "") {
        return false;
      }
      return true;
    } else {
      return true;
    }

  }

  submitOrder() {
    this.g.loaderDisplay = "display";
    if (!this.validation()) {
      this.g.loaderDisplay = "";
      return;
    }
    let apiMethod = '';
    let query: any = {
      organizationId: "1",
      accountOwnerId: this.user.accountOwnerId,
      sellerId: this.user.sellerId,
    }
    if (this.type == 'Order Detail') {
      apiMethod = 'getSellerOrderReports';
      query.toDate = moment(this.endDate).format('MM/DD/YYYY');
      //query.toDate =this.endDate;
      query.fromDate = moment(this.startDate).format('MM/DD/YYYY');
      //query.sourceType =this.sourceType||'';
    }
    this.api.getReports(apiMethod, query).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.orderListLength = false;
      this.orderList = data.getOHResponseList;
      if (!this.orderList.length) {
        this.orderListLength = true;
      }
      //this.alertService.success();
      //console.log(data);
    }, (err) => {
      this.alertService.error('Error', err);
      this.g.loaderDisplay = "";
    });
  }

}
